import { render, staticRenderFns } from "./StContact.vue?vue&type=template&id=04b7df8b"
import script from "./StContact.vue?vue&type=script&lang=ts"
export * from "./StContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports